<template>
  <div class="aside-attr table-panel" @click.stop>
    <div class="aside-attr-title"><span>表格样式</span>
      <a v-if="$store.getters['app/isAdmin']" class="c-f-right admin-edit-icon" @click="onAdminEdit"><i class="el-icon-edit"></i>编辑表格</a>
    </div>
    <div class="aside-attr-body" v-loading="loading" element-loading-text="正在替换表格..." element-loading-spinner="el-icon-loading">
      <section>
        <ul>
          <!--<li v-for="(item, index) in defaultList" :key="`d_${index}`">-->
            <!--<div class="img-box" @click="onDefAsideClick(item)" v-html="item.html"></div>-->
            <!--<p class="c-center">默认表格</p>-->
          <!--</li>-->
          <li v-for="(item, index) in dataList" :key="item.id"  :class="{'active': item.id === activeId}">
            <div class="img-box" @click="onAsideClick(item)">
              <img :src="item.viewImg" />
            </div>
            <p class="c-center">表格样式{{index + 1}}</p>
            <p class="c-center" v-if="$store.getters['app/isAdmin']"><a @click="onOpenWordTable(item)">修改样式</a> | <a @click="onDelTable(item)">删除</a></p>
          </li>
        </ul>
      </section>
      <div v-if="dataList.length === 0" class="noResult c-center" style="margin-top: 40px">
        <img src="img/noResult.png">
        <p class="c-gray">无表格样式</p>
      </div>
    </div>
    <div style="height: 0px; overflow: auto">
      <word-to-img ref="wordImgRef"  :html-str="imgData" :w-width="data.width"></word-to-img>
    </div>
  </div>
</template>
<script>
  import {module_group_edit, template_type_ppt} from '@/const.js';
  import {table_themes} from './table-html'
  import templateService from '@/request/service/template-service';
  import wordToImg from '../tpls-dialog/word-to-img';
  const TEXT_STYLE = [ 'color', 'fontSize', 'fontFamily', 'fontWeight'];
  const TD_STYLE = [ 'textAlign', 'verticalAlign', 'backgroundColor','borderStyle','borderColor'];
  const ROW_STYLE = [...TD_STYLE, ...TEXT_STYLE];
  export default {
    components: {
      wordToImg
    },
    props: {
      data: {
        type: Object
      },
      templateIds: Array,
      projectId: String,
    },
    data () {
      return {
        defaultList: table_themes,
        noResult: false,
        activeId: null,
        imgData: null,
        loading: false
      }
    },
    computed:{
      dataList(){
        return this.$store.state.templateGroup.tableThemeList;
      }
    },
    created () {
      this.init()
    },
    methods: {
      init(){
        this.getWordTableList();
      },
      getWordTableList(){
        let params = {
          templateIds: this.templateIds,
          projectId: this.projectId
        };
        templateService.getTemplateWordList(params).then((data) => {
          this.$store.commit('templateGroup/set_table_theme', data.list || []);
        });
      },
      onAdminEdit(){
        this.$emit('onOpenAdminDialog')
      },
      replaceClass(oldStr, className){
        if(!oldStr){
          return '';
        }
        let newDom = document.createElement('div');
        let oldDom = newDom.cloneNode();
        oldDom.innerHTML = oldStr;
        let table = oldDom.querySelector('table');
        table.className = className;
        this.imgData = oldDom.innerHTML;
        return this.imgData;
      },
      onDefAsideClick(item){
        this.activeId = item.id;
        this.loading = true;
        let htmlStr = this.replaceClass(item.html, item.className);
        this.$nextTick(() => {
          this.$refs.wordImgRef._getImg().then(({url}) => {
            this.$emit('onReplaceTableTheme', url, htmlStr)
          }).finally(() => {
            this.loading = false;
          })
        })
      },
      onAsideClick(item){
        this.activeId = item.id;
        this.loading = true;
        let htmlStr = this.replaceStyleData(this.data.htmlStr, item.html);
        this.$nextTick(() => {
          this.$refs.wordImgRef._getImg().then(({url}) => {
            this.$emit('onReplaceTableTheme', url, htmlStr)
          }).finally(() => {
            this.loading = false;
          })
        })
      },
      isTd(dom){
        return dom.tagName.toLowerCase() === 'td';
      },
      getStyle(dom, key, result){
        let value = dom.style[key];
        if(value){
          result.push({
            key: key,
            value: value
          });
        }else if(this.isTd(dom)){
          if(TD_STYLE.indexOf(key) > -1){
            let style = dom.style;
            result.push({
              key: key,
              value: style[key] || ''
            });
          }
          if(TEXT_STYLE.indexOf(key) > -1){
           let spanDom = dom.querySelector('span');
            if(spanDom){
              let style = spanDom.style;
              result.push({
                key: key,
                value: style[key] || ''
              });
            }
          }
          let strongDom = dom.querySelector('strong');
          if(strongDom){
            result.push({
              key: 'fontWeight',
              value: 'bold'
            });
          }
        }
      },
      getStyleList(dom){
        let result = [];
        ROW_STYLE.forEach((attr) => {
          this.getStyle(dom, attr, result);
        })
        return result;
      },
      getFirstRowHeaderHighlight(firstRow){
        let tdList = firstRow.children, result = {rowStyle: this.getStyleList(firstRow), tdListStyle: []};
        for (let i = 0 ; i < tdList.length ; i++) {
          result.tdListStyle.push(this.getStyleList(tdList[i]));
        }
        return result;
      },
      getRowHighlight(rows){
        let len = rows.length, row,rowNum, result = {rowStyle: [], tdListStyle: []};
        if(len > 1 && rows[1].style.backgroundColor){//奇数行，隔行变色
          row = rows[1];
          rowNum = 1;
        }else if(len > 2 && rows[2].style.backgroundColor){ // 偶数行隔行变色
          row = rows[2];
          rowNum = 2
        }
        if(row){
          let rowStyleList = this.getStyleList(row);
          let tdList = row.children;
          result = {rowNum: rowNum,rowStyle: rowStyleList, tdListStyle: []};
          for (let i = 0 ; i < tdList.length ; i++) {
            result.tdListStyle.push(this.getStyleList(tdList[i]));
          }
        }
        return result;
      },
      getFirstColHighlight(trList){
        let result = [], firstCol = null;
        for (let i = 0 ; i < trList.length ; i++) {
          firstCol = trList[i].children[0];
          result.push(this.getStyleList(firstCol));
        }
        return result;
      },
      replaceStyle(dom, styleList){
        if(!styleList){
          return;
        }
        let domStyleAttr = dom.style;
        let styleDataMap = {};
        styleList.forEach((item) => {
          styleDataMap[item.key] = item.value;
        });
        if(this.isTd(dom)){
          //替换td样式
          TD_STYLE.forEach((attr) => {
            dom.style[attr] = styleDataMap[attr] || null;
          });
          //替换td中文本样式
          let span = document.createElement('span');
          TEXT_STYLE.forEach((attr) => {
            span.style[attr] = styleDataMap[attr] || null;
          });
          span.textContent = dom.textContent;
          dom.textContent = '';
          dom.appendChild(span);
        }else{
          ROW_STYLE.forEach((attr) => {
            domStyleAttr[attr] = styleDataMap[attr] || null;
          });
        }
      },
      replaceRowStyle(trDom, styleObj){
        if(styleObj.rowStyle.length > 0){
          this.replaceStyle(trDom, styleObj.rowStyle);
        }
        let styleLen = styleObj.tdListStyle.length;
        if(styleLen > 0){
          let tdList = trDom.children, styleItem;
          for(let i = 0 ; i < tdList.length ; i++){
            if(i < styleLen){
              //主题表格列少于需替换的表格，可使用前一列的样式
              styleItem = styleObj.tdListStyle[i];
            }
            this.replaceStyle(tdList[i], styleItem);
          }
        }
      },
      replaceFirstColStyle(trList, styleList){
        let firstTd = null;
        for(let i = 0 ; i < trList.length ; i++){
          firstTd = trList[i].children[0];
          this.replaceStyle(firstTd, styleList[i]);
        }
      },
      replaceMoreRowStyle(trList, styleObj, rowNum){
        if(trList.length < 2){
          return;
        }
        for(let i = 1 ; i < trList.length ; i++){
          if(rowNum === 2 && i % rowNum === 0){ // 偶数行变色
            this.replaceRowStyle(trList[i], styleObj);
          }else if(rowNum === 1 && i % 2 !== 0){ //奇数行变色
            this.replaceRowStyle(trList[i], styleObj);
          }
        }
      },
      clearStyle(dom){
        ROW_STYLE.forEach((key) => {
          dom.style[key] = null;
        });
      },
      clearStyleForOldTable(trList){
        let temp;
        for(let i = 0 ; i < trList.length ; i++){
          this.clearStyle(trList[i]);
          temp = trList[i].children;
          for(let j = 0 ; j < temp.length ; j++){
            this.clearStyle(temp[j]);
          }
        }
      },
      replaceTableStyle(newTable, oldTable){
        let nStyle = newTable.style.cssText.split(';');
        let temp;
        nStyle = nStyle.filter((attr) => {
          temp = attr.trim();
          return temp && !(temp.startsWith('width:') || temp.startsWith('height:'));
        });
        let whArr = oldTable.style.cssText.split(';').filter((attr) => {
          temp = attr.trim();
          return temp && temp.startsWith('width:') || temp.startsWith('height:');
        });
        oldTable.style.cssText = nStyle.join(';') + ';' + whArr.join(';');
      },
      replaceStyleData(oldStr, newStr){
        if(!oldStr){
          this.imgData = newStr;
         return newStr;
        }

        let newDom = document.createElement('div');
        let oldDom = newDom.cloneNode();
        oldDom.innerHTML = oldStr;
        newDom.innerHTML = newStr;
        let oldTrList = oldDom.querySelector('tbody').children;
        let newTrList = newDom.querySelector('tbody').children;
        //清除格式
        this.clearStyleForOldTable(oldTrList);
        // table样式
        let newTable = newDom.querySelector('table'), oldTable = oldDom.querySelector('table')
        let border = newTable.getAttribute('border');
        oldTable.setAttribute('border', border);
        this.replaceTableStyle(newTable, oldTable);
        // 替换表头样式
        let firstRowStyleObj = this.getFirstRowHeaderHighlight(newTrList[0]);
        if(firstRowStyleObj.rowStyle.length > 0 || firstRowStyleObj.tdListStyle.length > 0){
          this.replaceRowStyle(oldTrList[0], firstRowStyleObj);
        }
        // 替换首列样式
        let colStyleList = this.getFirstColHighlight(newTrList);
        if(colStyleList.length > 0){
          this.replaceFirstColStyle(oldTrList, colStyleList);
        }
        // 隔行变色
        let rowsStyleObj = this.getRowHighlight(newTrList);
        if(rowsStyleObj.rowStyle.length > 0 || rowsStyleObj.tdListStyle.length > 0){
          this.replaceMoreRowStyle(oldTrList, rowsStyleObj, rowsStyleObj.rowNum);
        }
        this.imgData = oldDom.innerHTML;
        return this.imgData;
      },
      onDelTable(item){
        templateService.deleteTemplateWord([item.id], this.projectId).then(() => {
          this.$message.success('删除成功');
          this.getWordTableList();
        })
      },
      onOpenWordTable(item){
        this.$emit('onOpenThemeDialog', item)
      }
    }
  }
</script>
<style lang="scss">
  @import "./table-panel.scss";
</style>